import { Controller } from "@hotwired/stimulus"

// What follows the reader down an article: a thin progress line, and the table of contents marking the section they are in.
export default class extends Controller {
  static targets = ["article", "progress", "tocLink"]

  connect() {
    this.onScroll = () => {
      if (this.frame) return
      this.frame = requestAnimationFrame(() => { this.frame = null; this.update() })
    }
    window.addEventListener("scroll", this.onScroll, { passive: true })
    window.addEventListener("resize", this.onScroll)
    this.observeHeadings()
    this.update()
  }

  disconnect() {
    window.removeEventListener("scroll", this.onScroll)
    window.removeEventListener("resize", this.onScroll)
    this.observer?.disconnect()
    cancelAnimationFrame(this.frame)
  }

  update() {
    if (!this.hasArticleTarget) return

    const rect = this.articleTarget.getBoundingClientRect()
    const total = rect.height - window.innerHeight * 0.6
    const done = Math.min(Math.max(-rect.top / (total || 1), 0), 1)
    if (this.hasProgressTarget) this.progressTarget.style.transform = `scaleX(${done})`
  }

  // The heading nearest the top of the screen is the current section.
  observeHeadings() {
    const headings = this.element.querySelectorAll(".bl-article h2[id], .bl-article h3[id], .bl-faq[id]")
    if (!headings.length || !("IntersectionObserver" in window)) return

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => { if (entry.isIntersecting) this.mark(entry.target.id) })
    }, { rootMargin: "-90px 0px -70% 0px" })
    headings.forEach((heading) => this.observer.observe(heading))
  }

  mark(id) {
    this.tocLinkTargets.forEach((link) => {
      const active = link.dataset.section === id
      link.classList.toggle("is-active", active)
      if (active) link.setAttribute("aria-current", "location")
      else link.removeAttribute("aria-current")
    })
  }
}
